import React, { useEffect } from 'react';
import { ThemeProvider as NextThemeProvider } from 'next-themes';

// Theme types that map to next-themes
export type Theme = 'clear' | 'swiss';
export type NextTheme = 'clear' | 'swiss' | 'light' | 'dark' | 'system';

interface ThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Enhanced ThemeProvider - Uses next-themes as the foundation with CLEAR-specific logic
 *
 * This provider wraps next-themes and provides:
 * - URL parameter checking for 'swiss' theme
 * - localStorage persistence with 'clear-theme' key
 * - Theme mapping: clear -> light, swiss -> swiss
 * - SSR-safe initialization
 */
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme="clear"
      themes={['clear', 'swiss']}
      storageKey="clear-theme"
      enableSystem={false}
      disableTransitionOnChange={false}
    >
      <ThemeInitializer>{children}</ThemeInitializer>
    </NextThemeProvider>
  );
};

/**
 * ThemeInitializer - Handles URL parameter checking and initialization
 */
const ThemeInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    // Check URL parameter for swiss theme
    const params = new URLSearchParams(window.location.search);
    const urlTheme = params.get('theme');
    
    if (urlTheme === 'swiss') {
      // This will be handled by RouteThemeWrapper for URL sync
      // We just ensure the URL parameter is available for reading
    }
  }, []);

  return <>{children}</>;
};

// Re-export useTheme from next-themes for consistency
export { useTheme } from 'next-themes';